<template lang="pug">
.d-contents
  h2.text-none.text-h5.font-weight-bold.redesignBlack--text Основная информация
  p.text-body-1.redesignBlack--text.mt-4
    | Выберите
    | {{ event.options.frontend_params.getEntityName('nominations_override', 2) }},
    | на которые хотите подать заявки
  v-sheet(
    rounded="xl"
    flat
  ).mt-8.pa-8
    api-form(
      ref="form"
      v-model="formData"
      :fields="visibleFields"
      :observer-props="{ vid }"
      :method="(args) => method(args, null)"
      no-reset
    )
      template(v-slot:save-btn): div
      template(v-slot:requirements.actions="props")
        portal-target(
          :name="`${stepId}-actions`"
          :slot-props="{ ...props, loading: props.form.loading, action: props.form.action }"
        )
</template>

<script>
import ExtraUserRequirementsForm from '@/components/forms/ExtraUserRequirementsForm.vue';
import SelectNominations from '@/components/inputs/SelectNominations.vue';
import mixinForceRerender from '@/mixins/mixinForceRerender';

export default {
  components: {
    ExtraUserRequirementsForm,
  },
  mixins: [mixinForceRerender],
  props: {
    stepId: {
      type: [String, Number],
      required: true,
    },
    vid: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    applications: {
      type: Array,
      default: () => [],
    },
    method: {
      type: Function,
      required: true,
    },
    globalFields: {
      type: Array,
      default: () => [],
    },
    eventGroups: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    hasSelectedNominations() {
      return !!this.formData.nominations?.length;
    },
    fields() {
      const { event, formData, globalFields, applications, mixinRerenderTrigger, hasSelectedNominations } = this;

      const { nominations } = formData;

      return [
        {
          text: `Выберите ${event.options.frontend_params.getEntityName('nominations_override', 2)}`,
          rules: 'required',
          value: 'nominations',
          key: mixinRerenderTrigger,
          component: SelectNominations,
          component_attrs: {
            serializeData: (data) => {
              // Удаляем номинации, которые уже есть в заявках
              const applicationsNominationIds = applications.map(({ nomination_id }) => nomination_id);

              return data.filter((i) => !applicationsNominationIds.includes(i.id));
            },
            showAvailables: true,
            returnObject: true,
            showNested: !event.options.is_manual_group_management,
            nestedProps: {
              returnObject: true,
            },
            autoselect: true,
            autoselectProps: {
              whenHasOnlyDefault: true,
              whenHasNotManyGroups: true,
            },
            multiple: true,
            event,
          },
        },
        {
          value: 'requirements',
          hidden: !hasSelectedNominations,
          component: ExtraUserRequirementsForm,
          component_attrs: {
            event,
            nominations,
            'additional-fields': globalFields,
            hide: true,
          },
          component_events: {
            fieldsData: (val) => {
              this.$emit('fieldsData', val);
            },
            updated: () => {
              this.mixinRerenderTrigger += 1;
              this.$refs.form.reset();
            },
          },
        },
      ];
    },
    visibleFields() {
      return this.fields.filter(({ hidden }) => !hidden);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
